import * as React from "react";

import { ModifierGroups } from "@v1/components/editor/page/element-editor/components/modifierGroups";
import StickyBanners from "@v1/components/editor/page/element-editor/components/StickyBanners";
import { selectDraftComponentsModifierGroups } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

const DesignTab: React.FC = () => {
  return (
    <div className="relative flex flex-col gap-3">
      <div className="border-border border-b">
        <StickyBanners />
      </div>
      <ComponentModifiers />
    </div>
  );
};

const ComponentModifiers: React.FC = () => {
  const modifierGroups = useEditorSelector(selectDraftComponentsModifierGroups);

  if (!modifierGroups.length) {
    return null;
  }

  return <ModifierGroups groupTypes={modifierGroups} />;
};

export default DesignTab;
